/* global axios */
import ApiClient from './ApiClient';

class PipelineAPI extends ApiClient {
  constructor() {
    super('pipeline', { accountScoped: true });
  }

  getBoard(params = {}) {
    return axios.get(`${this.url}/board`, { params });
  }

  moveCard(conversationId, stage) {
    return axios.patch(`${this.url}/move`, {
      conversation_id: conversationId,
      stage,
    });
  }
}

export default new PipelineAPI();
